import { useSelector } from 'react-redux';
import { useLocale } from '../contexts/LocaleContext';
import * as types from '../types';
import { FREE_TRIAL_SHIPPING_CODE } from '../types/Product';

/**
 * Returns the free trial shipping price in cents for use in calculations.
 */
export default function useFreeTrialShippingPriceInCents(): number {
  const { currency } = useLocale();
  const shippingOptions = useSelector((state: types.AppState) => state.config.shippingOptions);

  const freeTrialShippingOption = shippingOptions.find((option) => option.code === FREE_TRIAL_SHIPPING_CODE);

  // 0 when the option is missing or not priced in this currency
  return freeTrialShippingOption?.pricingInCents[currency] ?? 0;
}
